//Componentes generales
import React, { useEffect, useState, useContext } from 'react';
import moment from 'moment';
import Select from 'react-select';

//Contexto
import activoContext from '../../context/activoContex/activoContex';
import activoTypeContext from '../../context/activoTypeContex/activoTypeContex';
import nivel1Context from '../../context/nivel1Context/nivel1Context.js';
import nivel2Context from '../../context/nivel2Context/nivel2Context.js';
import nivel3Context from '../../context/nivel3Context/nivel3Context.js';
import nivel4Context from '../../context/nivel4Context/nivel4Context.js';
import nivel5Context from '../../context/nivel5Context/nivel5Context.js';

//Tipos de Estado
import { STATES, ALERTSProcedimientosProgramados, ORIGENES, TIPPROCS, STATESProcsProgramados, CHECKLISTStates } from '../../utils/states';

//Tipos de Prioridades
import { PRIORITYA } from '../../utils/priority';

//Permisos
import { VER_USUARIOS } from '../../utils/permisos';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

// Estilos
import './AddFilter.css';
import { COLOR_BOTONES, COLOR_FONDO, PRINCIPAL, NAVBARS, COLOR_TEXTO} from '../../constants/colors';
import authContext from '../../context/authentication/authContex';

/* 
  Componente de vista dialogo de filtros.
  Donde currentUser es el usuario en sesión.
  usuarios contiene todos los usuarios disponibles.
  cerrar es la función encargada de ocultar el dialogo.
  filtro es la variable del context que define que requerimientos se muestran.
  aplicarFiltros es la función del context que setea el filtro del context.
  workspace es la variable que fltra cuando el usuario se mueve entre workspaces de estados (Ya definidos: Pendientes y Disponibles).
  checkPermisos es la función de la vista que chequea los permisos del usuario en sesión con el enviado por parametro.
*/
function AddFilter({ usuarios, cerrar, filtro, aplicarFiltros, workspace, selct, setSelec, filterTipoActivos, setFilterTipoActivos, getProductsByNroFor, componentePadre = 'OrdenesTrabajo', vistaActivo = false }) {
  
  const {usuario,getValorActualFromDictionary} = useContext(authContext);

  //States de Filtro Estado.
  const [filterEstado, setFilterEstado] = useState(filtro.filtrosEstado);
  //States de Filtro Rango.
  const [filterRango, setFilterRango] = useState(filtro.filtrosRango);
  //States de Estados Disponibles.
  const [statesAvailable, setStatesAvailable] = useState((componentePadre == 'OrdenesTrabajo') ? STATES : STATESProcsProgramados);
  const [origenesAvailable, setOrigenesAvailable] = useState(ORIGENES);
  const [alertsAvailable, setAlertsAvailable] = useState(ALERTSProcedimientosProgramados);
  const [statesChecklistAvailable,setStatesChecklistAvailable] = useState(CHECKLISTStates);
  const [tipProcsAvailables,setTipProcsAvailables] = useState((componentePadre != 'OrdenesTrabajo') ? TIPPROCS : []);
  //States de selección de "Todos" en usuario.
  /* const [allUsers, setAllUsers] = useState((filtro.filtrosEstado.userName.length === usuarios.length)); */

  // opciones para que se puedan ver todos los nombre de los activos
  const {activoList} = useContext(activoContext)
  const optionsActivos = activoList?.map((dato) =>({ value: dato.name, label: dato.name, activoID:dato._id, activoCod: dato.codActivo  })); 
  const {activoTypeList} = useContext(activoTypeContext)
  const optionsTypeActivos = activoTypeList?.map(dato => ({value: dato.codTypeActivo, label: dato.nameTypeActivo, id: dato._id}));

  const {nivel1Lista} = useContext(nivel1Context);
  const nivel1Options = nivel1Lista?.map(lv1 => ({label:lv1.name, value: lv1._id}))
  const {nivel2List} = useContext(nivel2Context);
  const nivel2Options = nivel2List?.map(lv2 => ({label:lv2.name, value: lv2._id}))
  const {nivel3List} = useContext(nivel3Context);
  const nivel3Options = nivel3List?.map(lv3 => ({label:lv3.nameNivel3, value: lv3._id}))
  const {nivel4List} = useContext(nivel4Context);
  const nivel4Options = nivel4List?.map(lv4 => ({label:lv4.name, value: lv4._id}))
  const {nivel5List} = useContext(nivel5Context);
  const nivel5Options = nivel5List?.map(lv5 => ({label:lv5.name, value: lv5._id}))

  /*
    Manejador de filtros de estados ante selección. 
    Donde bool es true si fue seleccionado o false si no lo fue. 
    state es el state que fue seleccionado o deseleccionado.
    El parametro bool determina si se agrega al filtro o si se quita al momento de filtrar.
  */
  const handlerClickState = (bool, state) => {
    const temp = filterEstado.state;
    if (bool && !temp.includes(state)) {
      temp.push(state);
      setFilterEstado({ ...filterEstado, state: temp });
    } else {
      const temp2 = temp.filter(f => f !== state);
      setFilterEstado({ ...filterEstado, state: temp2 });
    }
  };
  const handlerClickTipoAlerta = (bool, tAlerta) => {
    const temp = filterEstado.tipoAlerta;
    if (bool && !temp.includes(tAlerta)) {
      temp.push(tAlerta);
      setFilterEstado({ ...filterEstado, tipoAlerta: temp });
    } else {
      const temp2 = temp.filter(f => f !== tAlerta);
      setFilterEstado({ ...filterEstado, tipoAlerta: temp2 });
    }
  };
  const handlerClickStateChecklist = (bool, tStateCheck) => {
    const temp = filterEstado.statesChecklist;
    if (bool && !temp.includes(tStateCheck)) {
      temp.push(tStateCheck);
      setFilterEstado({ ...filterEstado, statesChecklist: temp });
    } else {
      const temp2 = temp.filter(f => f !== tStateCheck);
      setFilterEstado({ ...filterEstado, statesChecklist: temp2 });
    }
  };
  const handlerClickTipoProcedimiento = (bool, tProc) => {
    const temp = filterEstado.tipoProcedimientos;
    if (bool && !temp.includes(tProc)) {
      temp.push(tProc);
      setFilterEstado({ ...filterEstado, tipoProcedimientos: temp });
    } else {
      const temp2 = temp.filter(f => f !== tProc);
      setFilterEstado({ ...filterEstado, tipoProcedimientos: temp2 });
    }
  };
  const handlerClickStateProcedimiento = (bool, tProc) => {
    const temp = filterEstado.statesProcedimientos;
    if (bool && !temp.includes(tProc)) {
      temp.push(tProc);
      setFilterEstado({ ...filterEstado, statesProcedimientos: temp });
    } else {
      const temp2 = temp.filter(f => f !== tProc);
      setFilterEstado({ ...filterEstado, statesProcedimientos: temp2 });
    }
  };
  const handlerClickOrigenes = (bool, ori) => {
    const temp = filterEstado.origenes;
    if (bool && !temp.includes(ori)) {
      temp.push(ori);
      setFilterEstado({ ...filterEstado, origenes: temp });
    } else {
      const temp2 = temp.filter(f => f !== ori);
      setFilterEstado({ ...filterEstado, origenes: temp2 });
    }
  };

  /*
        Manejador de filtros de prioridades ante selección.
            Donde bool es true si fue seleccionado o false si no lo fue. 
                  state es el state que fue seleccionado o deseleccionado.
        El parametro bool determina si se agrega al filtro o si se quita al momento de filtrar.
    */
  const handlerClickPriority = (bool, prior) => {
    const temp = filterEstado.priority;
    if (bool && !temp.includes(prior)) {
      temp.push(prior);
      setFilterEstado({ ...filterEstado, priority: temp });
    } else {
      const temp2 = temp.filter(f => f !== prior);
      setFilterEstado({ ...filterEstado, priority: temp2 });
    }
  };

  /*
        Manejador de filtro ante cambio de fecha Desde.
            Donde data es la fecha ingresada por el usuario. 
        El parametro data es el valor con el que se setea el filtro de rango fecha Desde.
    */
  const handlerChangeFecaltDesde = data => {
    // El input type="date" siempre entrega el valor en formato "AAAA-MM-DD".
    const casteo = new Date(`${data}T00:00:00`);

    setFilterRango({
      ...filterRango,
      fecAlt: { ...filterRango.fecAlt, desde: casteo },
    });
  };

  /*const handlerChangeFecaltDesde = (campo , value) => {
        setFilterRango({...filterRango, fecAlt: {...filterRango.fecAlt, campo: value}});
    }*/

  /*
        Manejador de filtro ante cambio de fecha Hasta.
            Donde data es la fecha ingresada por el usuario. 
        El parametro data es el valor con el que se setea el filtro de rango fecha Hasta.
    */
  const handlerChangeFecaltHasta = data => {
    // El input type="date" siempre entrega el valor en formato "AAAA-MM-DD".
    const casteo = new Date(`${data}T00:00:00`);

    setFilterRango({
      ...filterRango,
      fecAlt: { ...filterRango.fecAlt, hasta: casteo },
    });
  };

  /*
        Manejador de filtro ante cambio de fecha Entrega.
            Donde data es la fecha ingresada por el usuario. 
        El parametro data es el valor con el que se setea el filtro de rango fecha Entrega.
    */
  const handlerChangeDeliveryDate = data => {
    // El input type="date" siempre entrega el valor en formato "AAAA-MM-DD".
    const casteo = new Date(`${data}T00:00:00`);

    setFilterRango({ ...filterRango, deliveryDate: casteo });
  };
  const handlerChangeDate = (data,property) => {
    // El input type="date" siempre entrega el valor en formato "AAAA-MM-DD".
    const casteo = new Date(`${data}T00:00:00`);

    setFilterRango({ ...filterRango, [property]: casteo });
  };

  /*
        Manejador de filtro usuarios ante selección.
            Donde bool es true si fue seleccionado o false si no lo fue. 
                  state es el state que fue seleccionado o deseleccionado.
        El parametro bool determina si se agrega al filtro o si se quita al momento de filtrar.   
    */
  const handlerClickUsers = (bool, user) => {
    if (bool) {
      setFilterEstado(filterEstadoAnterior => ({
        ...filterEstadoAnterior,
        userName: [...filterEstado.userName, user],
      }));
    } else {
      setFilterEstado(filterEstadoAnterior => ({
        ...filterEstadoAnterior,
        userName: filterEstado.userName.filter(i => i !== user),
      }));
    }
  };

  /*
        Aplica los filtros seteados llamando a la función del context en views.
        Una vez aplicados, cierra el presente dialogo.
    */
  const handlerAplicaFiltros = (estado, rango) => {
    aplicarFiltros({ filterEstado: {...estado}, filterRango: rango });
    cerrar(null);
  };

  const handleChengeActivo =  (taSelccionado) => {
    setSelec(taSelccionado)
    const codActivo = taSelccionado?.map(activoCod => activoCod.activoCod)
    setFilterEstado({ ...filterEstado, activos: codActivo })
  }

  const handleChangeTipoActivo = (value) => {
    setFilterTipoActivos(value);
    const codActivo = value?.map(activoCod => activoCod.value)
    setFilterEstado({ ...filterEstado, tipoActivos: codActivo })
  }

  const handleNvSelected = (value, prop = "lv1") => {
    let activosFiltered = activoList?.filter(a => {
      switch(prop){
        case "lv1":
          return a.activoNivel1ID == value.value
          break;
        case "lv2":
          return a.activoNivel2ID == value.value
          break;
        case "lv3":
          return a.activoNivel3ID == value.value
          break;
        case "lv4":
          return a.activoNivel4ID == value.value
          break;
        case "lv5":
          return a.activoNivel5ID == value.value
          break;
        default:
          return false;
          break;
      }
    }) ?? [];
    
    let activosModelados = activosFiltered?.filter(a => !selct.some(act => a.codActivo == act.activoCod)).map(a => ({activoCod: a.codActivo, activoID: a._id, label: a.name, value:a.name}));
    
    setSelec([...selct, ...activosModelados]);
    
    setFilterEstado({...filterEstado, activos: [...filterEstado.activos, ...activosModelados?.filter(a => !filterEstado.activos.some(act => a.activoCod == act)).map(a => a.activoCod)]}); 
  }

  return (
    <div className="container-gr-filter" >
      <div className="label-filter-icon-r">
        <div className="filter-title-r" style={{backgroundColor: PRINCIPAL, color: NAVBARS}}>Filtros</div>
        <div className="filter-icon-r">
          <FontAwesomeIcon
            icon={faXmark}
            onClick={() => cerrar(null)}
          />
        </div>
      </div>
      <div>
        {componentePadre != 'OrdenesTrabajo' && componentePadre != 'Consumos' && componentePadre != 'ChecklistReg' && componentePadre != 'OPD' && componentePadre != 'ControlServicios' && <div className="container-gr-filter-fil">
          <div style={{display: "flex", borderWidth: 1, justifyContent: "space-between"}}>
            <div className="container-gr-subtitles">Tipo de Alerta</div>
            
            {(workspace.todos === 1) ?
              <button
                className='button-todos'
                style={{boxShadow: "4px 5px 5px -3px rgba(0,0,0,0.23)", backgroundColor: COLOR_BOTONES}}
                onClick={() => { setFilterEstado({ ...filterEstado, tipoAlerta: (filterEstado.tipoAlerta.length === ALERTSProcedimientosProgramados.length) ? [] : ALERTSProcedimientosProgramados })}}
              >
                {(filterEstado.tipoAlerta.length === ALERTSProcedimientosProgramados.length) ? "Deseleccionar Todos" : "Seleccionar Todos"}
              </button>
              :
              <div></div>
            }

          </div>

          <div className="filter-container-states">
            <div className="filter-container-states-gr">
                <div style={{display: "flex"}}>
                  {alertsAvailable.map(function (st, indexS) {
                    if (workspace.pendientes || workspace.disponibles) {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input
                            type="checkbox" id={`state-${indexS}`} name="states"
                            value={st} disabled 
                            defaultChecked={ filterEstado.tipoAlerta.includes(st) ? true : false }
                            onClick={ bool => handlerClickTipoAlerta(bool.target.checked, st) }
                          />
                          <label htmlFor={`state-${indexS}`} className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                    } else {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input type="checkbox" name={`state-${st}`} value={st}
                            checked={ filterEstado.tipoAlerta.includes(st) ? true : false }
                            onChange={bool => handlerClickTipoAlerta(bool.target.checked, st)}
                          />
                          <label className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                    }
                  })}
                </div>
            </div>
          </div>
        </div>}
        
        {componentePadre == 'ChecklistReg' && <div className="container-gr-filter-fil">
          <div style={{display: "flex", borderWidth: 1, justifyContent: "space-between"}}>
            <div className="container-gr-subtitles">Checklist con...</div>
            
            {(workspace.todos === 1) ?
              <button
                className='button-todos'
                style={{boxShadow: "4px 5px 5px -3px rgba(0,0,0,0.23)", backgroundColor: COLOR_BOTONES}}
                onClick={() => { setFilterEstado({ ...filterEstado, statesChecklist: (filterEstado.statesChecklist.length === CHECKLISTStates.length) ? [] : CHECKLISTStates })}}
              >
                {(filterEstado.statesChecklist.length === CHECKLISTStates.length) ? "Deseleccionar Todos" : "Seleccionar Todos"}
              </button>
              :
              <div></div>
            }

          </div>

          <div className="filter-container-states">
            <div className="filter-container-states-gr">
                <div style={{display: "flex"}}>
                  {statesChecklistAvailable.map(function (st, indexS) {
                    if (workspace.ctrlFallidos){
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input
                            type="checkbox" id={`state-${indexS}`} name="states"
                            value={st} disabled 
                            defaultChecked={ filterEstado.statesChecklist.includes(st) ? true : false }
                            onClick={ bool => handlerClickStateChecklist(bool.target.checked, st) }
                          />
                          <label htmlFor={`state-${indexS}`} className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                    } else {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input type="checkbox" name={`state-${st}`} value={st}
                            checked={ filterEstado.statesChecklist.includes(st) ? true : false }
                            onChange={bool => handlerClickStateChecklist(bool.target.checked, st)}
                          />
                          <label className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                    }
                  })}
                </div>
            </div>
          </div>
        </div>}
        
        {(componentePadre == 'ProcedimientosProgramados' ) && <div className="container-gr-filter-fil">
          <div style={{display: "flex", borderWidth: 1, justifyContent: "space-between"}}>
            <div className="container-gr-subtitles">Estado</div>
            
            {(workspace.todos === 1) ?
              <button
                className='button-todos'
                style={{boxShadow: "4px 5px 5px -3px rgba(0,0,0,0.23)", backgroundColor: COLOR_BOTONES}}
                onClick={() => { setFilterEstado({ ...filterEstado, statesProcedimientos: (filterEstado.statesProcedimientos.length == STATESProcsProgramados.length) ? [] : STATESProcsProgramados})}}
              >
                {(filterEstado.statesProcedimientos.length === STATESProcsProgramados.length) ? "Deseleccionar Todos" : "Seleccionar Todos"}
              </button>
              :
              <div></div>
            }

          </div>

          <div className="filter-container-states">
            <div className="filter-container-states-gr">
                <div style={{display: "flex"}}>
                  {statesAvailable.map(function (st, indexS) {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input type="checkbox" name={`state-${st}`} value={st}
                            checked={ filterEstado.statesProcedimientos.includes(st) ? true : false }
                            onChange={bool => handlerClickStateProcedimiento(bool.target.checked, st)}
                          />
                          <label className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                  })}
                </div>
            </div>
          </div>
        </div>}
        
        {(['ReportesODT', 'ProcedimientosProgramados'].includes(componentePadre)) && <div className="container-gr-filter-fil">
          <div style={{display: "flex", borderWidth: 1, justifyContent: "space-between"}}>
            <div className="container-gr-subtitles">Origen:</div>
            
              <button
                className='button-todos'
                style={{boxShadow: "4px 5px 5px -3px rgba(0,0,0,0.23)", backgroundColor: COLOR_BOTONES}}
                onClick={() => { setFilterEstado({ ...filterEstado, origenes: (filterEstado.origenes.length == ORIGENES.length) ? [] : ORIGENES})}}
              >
                {(filterEstado.origenes.length === ORIGENES.length) ? "Deseleccionar Todos" : "Seleccionar Todos"}
              </button>

          </div>

          <div className="filter-container-states">
            <div className="filter-container-states-gr">
                <div style={{display: "flex"}}>
                  {origenesAvailable.map(function (o, indexS) {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input type="checkbox" name={`state-${o}`} value={o}
                            checked={ filterEstado.origenes.includes(o) ? true : false }
                            onChange={bool => handlerClickOrigenes(bool.target.checked, o)}
                          />
                          <label className="filter-priority-item-label">
                            {o}
                          </label>
                        </div>
                      );
                  })}
                </div>
            </div>
          </div>
        </div>}

        {(componentePadre == 'ProcedimientosProgramados' ) && <div className="container-gr-filter-fil">
          <div style={{display: "flex", borderWidth: 1, justifyContent: "space-between"}}>
            <div className="container-gr-subtitles">Tipo de Procedimiento</div>
            
            {(workspace.todos === 1) ?
              <button
                className='button-todos'
                style={{boxShadow: "4px 5px 5px -3px rgba(0,0,0,0.23)", backgroundColor: COLOR_BOTONES}}
                onClick={() => { setFilterEstado({ ...filterEstado, tipoProcedimientos: (filterEstado.tipoProcedimientos.length === TIPPROCS.length) ? [] : TIPPROCS})}}
              >
                {(filterEstado.tipoProcedimientos.length === TIPPROCS.length) ? "Deseleccionar Todos" : "Seleccionar Todos"}
              </button>
              :
              <div></div>
            }

          </div>

          <div className="filter-container-states">
            <div className="filter-container-states-gr">
                <div style={{display: "flex"}}>
                  {tipProcsAvailables.map(function (st, indexS) {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input type="checkbox" name={`state-${st}`} value={st}
                            checked={ filterEstado.tipoProcedimientos.includes(st) ? true : false }
                            onChange={bool => handlerClickTipoProcedimiento(bool.target.checked, st)}
                          />
                          <label className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                  })}
                </div>
            </div>
          </div>
        </div>}

        {(componentePadre == 'OrdenesTrabajo') && <div className="container-gr-filter-fil">
          <div style={{display: "flex", borderWidth: 1, justifyContent: "space-between"}}>
            <div className="container-gr-subtitles">Estados</div>
            
            {(workspace.todos === 1) ?
              <button
                className='button-todos'
                style={{boxShadow: "4px 5px 5px -3px rgba(0,0,0,0.23)", backgroundColor: COLOR_BOTONES}}
                onClick={() => { setFilterEstado({ ...filterEstado, state: (filterEstado.state.length === STATES.length) ? [] : STATES})}}
              >
                {(filterEstado.state.length === STATES.length) ? "Deseleccionar Todos" : "Seleccionar Todos"}
              </button>
              :
              <div></div>
            }

          </div>

          <div className="filter-container-states">
            <div className="filter-container-states-gr">
                <div style={{display: "flex"}}>
                  {statesAvailable.map(function (st, indexS) {
                    if (workspace.pendientes || workspace.ennivel3) {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input
                            type="checkbox" id={`state-${indexS}`} name="states"
                            value={st} disabled 
                            defaultChecked={ filterEstado.state.includes(st) ? true : false }
                            onClick={ bool => handlerClickState(bool.target.checked, st) }
                          />
                          <label htmlFor={`state-${indexS}`} className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                    } else {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input type="checkbox" name={`state-${st}`} value={st}
                            checked={ filterEstado.state.includes(st) ? true : false }
                            onChange={bool => handlerClickState(bool.target.checked, st)}
                          />
                          <label className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                    }
                  })}
                </div>
            </div>
          </div>
        </div>}

        {componentePadre == 'OPD' && <div className="container-gr-filter-fil">
          <div style={{display: "flex", borderWidth: 1, justifyContent: "space-between"}}>
            <div className="container-gr-subtitles">Estados</div>

            {(workspace.todos === 1) ?
              <button
                className='button-todos'
                style={{boxShadow: "4px 5px 5px -3px rgba(0,0,0,0.23)", backgroundColor: COLOR_BOTONES}}
                onClick={() => { setFilterEstado({ ...filterEstado, state: (filterEstado.state.length === 3) ? [] : ['PENDIENTE', 'ENPROCESO', 'FINALIZADA']})}}
              >
                {(filterEstado.state.length === 3) ? "Deseleccionar Todos" : "Seleccionar Todos"}
              </button>
              :
              <div></div>
            }

          </div>

          <div className="filter-container-states">
            <div className="filter-container-states-gr">
                <div style={{display: "flex"}}>
                  {['PENDIENTE', 'ENPROCESO', 'FINALIZADA'].map(function (st, indexS) {
                    if (workspace.pendientes || workspace.enproceso) {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input
                            type="checkbox" id={`state-opd-${indexS}`} name="states"
                            value={st} disabled
                            defaultChecked={ filterEstado.state.includes(st) ? true : false }
                            onClick={ bool => handlerClickState(bool.target.checked, st) }
                          />
                          <label htmlFor={`state-opd-${indexS}`} className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                    } else {
                      return (
                        <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f" key={indexS}>
                          <input type="checkbox" name={`state-opd-${st}`} value={st}
                            checked={ filterEstado.state.includes(st) ? true : false }
                            onChange={bool => handlerClickState(bool.target.checked, st)}
                          />
                          <label className="filter-priority-item-label">
                            {st}
                          </label>
                        </div>
                      );
                    }
                  })}
                </div>
            </div>
          </div>
        </div>}

        {componentePadre == 'OPD' && <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Revisada para Producción {vistaActivo && <span style={{fontSize: '0.8rem', color: '#666'}}>(bloqueado en vista por activo)</span>}</div>
          <div className="filter-container-states">
            <div className="filter-container-states-gr">
              <div style={{display: "flex"}}>
                <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f">
                  <input
                    type="checkbox"
                    name="revisada-no"
                    disabled={vistaActivo}
                    checked={filterEstado.revisadaProduccion?.includes(false) ?? true}
                    onChange={(e) => {
                      const current = filterEstado.revisadaProduccion ?? [false, true];
                      if(e.target.checked) {
                        setFilterEstado({ ...filterEstado, revisadaProduccion: [...current.filter(v => v !== false), false] });
                      } else {
                        setFilterEstado({ ...filterEstado, revisadaProduccion: current.filter(v => v !== false) });
                      }
                    }}
                  />
                  <label className="filter-priority-item-label">Sin revisar</label>
                </div>
                <div style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}} className="container-states-f">
                  <input
                    type="checkbox"
                    name="revisada-si"
                    disabled={vistaActivo}
                    checked={filterEstado.revisadaProduccion?.includes(true) ?? true}
                    onChange={(e) => {
                      const current = filterEstado.revisadaProduccion ?? [false, true];
                      if(e.target.checked) {
                        setFilterEstado({ ...filterEstado, revisadaProduccion: [...current.filter(v => v !== true), true] });
                      } else {
                        setFilterEstado({ ...filterEstado, revisadaProduccion: current.filter(v => v !== true) });
                      }
                    }}
                  />
                  <label className="filter-priority-item-label">Revisadas</label>
                </div>
              </div>
            </div>
          </div>
        </div>}

        {(componentePadre != 'ProcedimientosProgramados' && componentePadre != 'ChecklistReg' && componentePadre != 'Documentos' && componentePadre != 'Consumos' && componentePadre != 'ControlServicios') && <div id="priority" className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Prioridad</div>
          <div className="filter-container-priority">
            {PRIORITYA.map(function (item, indexP) {
              return (
                <div className="filter-priority-item" key={indexP}>
                  <input type="checkbox" id={`priority-${indexP}`} name="item" value={item.id}
                    defaultChecked={filterEstado.priority.includes(indexP) ? true : false}
                    onClick={bool => handlerClickPriority(bool.target.checked, item.id)}
                  />
                  <label htmlFor={`priority-${indexP}`} className="filter-priority-item-label">
                    {item.descr}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        }

        {componentePadre != 'Documentos' && componentePadre != 'ControlServicios' && <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Fecha de Alta</div>
          <div className="filter-container-date">
            <div className="filter-date-item">
              <div className="filter-date-item-label">Desde</div>
              <input type="date" style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}} className="label-AddFilter-fecha"
                defaultValue={moment(filterRango.fecAlt.desde).format('YYYY-MM-DD')}
                onChange={data => handlerChangeFecaltDesde(data.target.value)}
                />
            </div>
            <div className="filter-date-item">
              <div className="filter-date-item-label">Hasta</div>
              <input type="date" className="label-AddFilter-fecha" style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}}
                defaultValue={moment(filterRango.fecAlt.hasta).format('YYYY-MM-DD')}
                onChange={data => handlerChangeFecaltHasta(data.target.value)}
                />
            </div>
          </div>
        </div>
        }

        {(componentePadre != 'ProcedimientosProgramados' && componentePadre != 'Consumos' && componentePadre != 'ChecklistReg'  && componentePadre != 'Documentos' && componentePadre != 'ControlServicios') && <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Fecha de Entrega Hasta</div>
          <div className="filter-container-date-h">
            <input type="date" className="label-AddFilter-fecha" style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}}
              defaultValue={moment(filterRango.deliveryDate).format('YYYY-MM-DD')}
              onChange={data => handlerChangeDeliveryDate(data.target.value)}
            />
          </div>
        </div>}

        {componentePadre == 'OPD' && <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Fecha de Completado (solo Finalizadas)</div>
          <div className="filter-container-date">
            <div className="filter-date-item">
              <div className="filter-date-item-label">Desde</div>
              <input type="date" style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}} className="label-AddFilter-fecha"
                defaultValue={filterRango.fechaCompletado?.desde ? moment(filterRango.fechaCompletado.desde).format('YYYY-MM-DD') : ''}
                onChange={data => {
                  const [day, month, year] = data.target.value.split("/");
                  const dateISOFormat = `${year}-${month}-${day}`;
                  const casteo = new Date(dateISOFormat);
                  setFilterRango({
                    ...filterRango,
                    fechaCompletado: { ...filterRango.fechaCompletado, desde: casteo }
                  });
                }}
              />
            </div>
            <div className="filter-date-item">
              <div className="filter-date-item-label">Hasta</div>
              <input type="date" className="label-AddFilter-fecha" style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}}
                defaultValue={filterRango.fechaCompletado?.hasta ? moment(filterRango.fechaCompletado.hasta).format('YYYY-MM-DD') : ''}
                onChange={data => {
                  const [day, month, year] = data.target.value.split("/");
                  const dateISOFormat = `${year}-${month}-${day}`;
                  const casteo = new Date(dateISOFormat);
                  setFilterRango({
                    ...filterRango,
                    fechaCompletado: { ...filterRango.fechaCompletado, hasta: casteo }
                  });
                }}
              />
            </div>
          </div>
        </div>}

        {(componentePadre == 'Documentos') && <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Fecha de Vencimiento Desde</div>
          <div className="filter-container-date-h">
            <input type="date" className="label-AddFilter-fecha" style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}}
              defaultValue={moment(filterRango.fecVencimientoDesde).format('YYYY-MM-DD')}
              name='fecVencimientoDesde'
              onChange={data => handlerChangeDate(data.target.value,data.target.name)}
            />
          </div>
        </div>}

        {(componentePadre == 'ProcedimientosProgramados' || componentePadre == 'Documentos') && <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Fecha de Vencimiento Hasta</div>
          <div className="filter-container-date-h">
            <input type="date" className="label-AddFilter-fecha" style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}}
              defaultValue={moment(filterRango.fecVencimientoHasta).format('YYYY-MM-DD')}
              name='fecVencimientoHasta'
              onChange={data => handlerChangeDate(data.target.value,data.target.name)}
            />
          </div>
        </div>}

        {(componentePadre == 'ProcedimientosProgramados') && <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Fecha de Completado Hasta</div>
          <div className="filter-container-date-h">
            <input type="date" className="label-AddFilter-fecha" style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}}
              defaultValue={moment(filterRango.fecCompletadoHasta).format('YYYY-MM-DD')}
              name='fecCompletadoHasta'
              onChange={data => handlerChangeDate(data.target.value,data.target.name)}
            />
          </div>
        </div>}

        {componentePadre == 'ProcedimientosProgramados' || componentePadre == 'Consumos' && <div className="container-gr-filter-fil">
                <div className="container-gr-subtitles">Tipo de Activos: </div>
                <div className='container-checkbox-box'>      
                <Select
                    styles={{
                        multiValueLabel: (base) => ({
                        ...base,
                        backgroundColor: "#00D4E2",
                        color: 'white',
                        borderRadius: "none",
                        fontSize: "1rem"
                        }), 
                        multiValueRemove: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }),
                    }}
                    isMulti
                    placeholder="Selecciona los tipo de activos"
                    options={optionsTypeActivos}
                    value={filterTipoActivos}
                    onChange={(selectedOption) => handleChangeTipoActivo(selectedOption)}
                />
                </div>
            </div>
        }
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Activos: </div>
          <div className='container-checkbox-box'>      
            <Select
                styles={{
                    multiValueLabel: (base) => ({
                    ...base,
                    backgroundColor: "#00D4E2",
                    color: 'white',
                    borderRadius: "none",
                    fontSize: "1rem"
                    }),
                    multiValueRemove: (base) => ({
                        ...base,
                        backgroundColor: "#00D4E2",
                        color: 'white',
                        borderRadius: "none",
                        fontSize: "1rem"
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                    }),
                }}
                isMulti
                menuPortalTarget={document.body}
                placeholder="Selecciona los activos"
                options={optionsActivos}
                isDisabled={usuario.activosAllowed && usuario.activosAllowed.length > 0 }
                value={usuario.activosAllowed && usuario.activosAllowed.length > 0 ? usuario.activosAllowed : selct}
                onChange={(selectedOption) => handleChengeActivo(selectedOption)}
            />
          </div>
        </div>
        
        {componentePadre != 'ControlServicios' && <>
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Filtrar por {getValorActualFromDictionary("Nivel 1")}: </div>
          <div className='container-checkbox-box'>
            <Select
                styles={{
                    multiValueLabel: (base) => ({
                    ...base,
                    backgroundColor: "#00D4E2",
                    color: 'white',
                    borderRadius: "none",
                    fontSize: "1rem"
                    }),
                    multiValueRemove: (base) => ({
                        ...base,
                        backgroundColor: "#00D4E2",
                        color: 'white',
                        borderRadius: "none",
                        fontSize: "1rem"
                    }),
                }}
                placeholder={`Selecciona ${getValorActualFromDictionary("Nivel 1")}`}
                options={nivel1Options}
                isDisabled={usuario.activosAllowed?.length > 0 }
                value={[]}
                onChange={(selectedOption) => handleNvSelected(selectedOption)}
            />
          </div>
        </div>
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Filtrar por {getValorActualFromDictionary("Nivel 2")}: </div>
          <div className='container-checkbox-box'>
            <Select
                styles={{
                    multiValueLabel: (base) => ({
                    ...base,
                    backgroundColor: "#00D4E2",
                    color: 'white',
                    borderRadius: "none",
                    fontSize: "1rem"
                    }),
                    multiValueRemove: (base) => ({
                        ...base,
                        backgroundColor: "#00D4E2",
                        color: 'white',
                        borderRadius: "none",
                        fontSize: "1rem"
                    }),
                }}
                placeholder={`Selecciona ${getValorActualFromDictionary("Nivel 2")}`}
                options={nivel2Options}
                isDisabled={usuario.activosAllowed?.length > 0 }
                value={[]}
                onChange={(selectedOption) => handleNvSelected(selectedOption, 'lv2')}
            />
          </div>
        </div>
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Filtrar por {getValorActualFromDictionary("Nivel 3")}: </div>
          <div className='container-checkbox-box'>
            <Select
                styles={{
                    multiValueLabel: (base) => ({
                    ...base,
                    backgroundColor: "#00D4E2",
                    color: 'white',
                    borderRadius: "none",
                    fontSize: "1rem"
                    }),
                    multiValueRemove: (base) => ({
                        ...base,
                        backgroundColor: "#00D4E2",
                        color: 'white',
                        borderRadius: "none",
                        fontSize: "1rem"
                    }),
                }}
                placeholder={`Selecciona ${getValorActualFromDictionary("Nivel 3")}`}
                options={nivel3Options}
                isDisabled={usuario.activosAllowed?.length > 0 }
                value={[]}
                onChange={(selectedOption) => handleNvSelected(selectedOption, 'lv3')}
            />
          </div>
        </div>
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Filtrar por {getValorActualFromDictionary("Nivel 4")}: </div>
          <div className='container-checkbox-box'>
            <Select
                styles={{
                    multiValueLabel: (base) => ({
                    ...base,
                    backgroundColor: "#00D4E2",
                    color: 'white',
                    borderRadius: "none",
                    fontSize: "1rem"
                    }),
                    multiValueRemove: (base) => ({
                        ...base,
                        backgroundColor: "#00D4E2",
                        color: 'white',
                        borderRadius: "none",
                        fontSize: "1rem"
                    }),
                }}
                placeholder={`Selecciona ${getValorActualFromDictionary("Nivel 4")}`}
                options={nivel4Options}
                isDisabled={usuario.activosAllowed?.length > 0 }
                value={[]}
                onChange={(selectedOption) => handleNvSelected(selectedOption, 'lv4')}
            />
          </div>
        </div>
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Filtrar por {getValorActualFromDictionary("Nivel 5")}: </div>
          <div className='container-checkbox-box'>
            <Select
                styles={{
                    multiValueLabel: (base) => ({
                    ...base,
                    backgroundColor: "#00D4E2",
                    color: 'white',
                    borderRadius: "none",
                    fontSize: "1rem"
                    }),
                    multiValueRemove: (base) => ({
                        ...base,
                        backgroundColor: "#00D4E2",
                        color: 'white',
                        borderRadius: "none",
                        fontSize: "1rem"
                    }),
                }}
                placeholder={`Selecciona ${getValorActualFromDictionary("Nivel 5")}`}
                options={nivel5Options}
                isDisabled={usuario.activosAllowed?.length > 0 }
                value={[]}
                onChange={(selectedOption) => handleNvSelected(selectedOption, 'lv5')}
            />
          </div>
        </div>
        </>}

        {usuarios.length > 0 && componentePadre != 'Documentos' &&(
          <div
            id="users"
            className="container-gr-filter-fil"
          >

            <div style={{display: "flex", borderWidth: 1, justifyContent: "space-between"}}>
              <div className="container-gr-subtitles">Usuarios</div>
              <button
                className='button-todos'
                style={{boxShadow: "4px 5px 5px -3px rgba(0,0,0,0.23)", backgroundColor: COLOR_BOTONES}}
                onClick={() => { setFilterEstado({ ...filterEstado, userName: (filterEstado.userName.length === usuarios.length) ? [] : usuarios.map((u) => u.userName) })}}
              >
                {(filterEstado.userName.length === usuarios.length) ? "Deseleccionar Todos" : "Seleccionar Todos"}
              </button>
            </div>
            <div className="filter-container-states">
              <div className="filter-container-states-gr">
                {usuarios.map(function (u, indexU) {
                  return (
                    <div
                      style={{backgroundColor: COLOR_FONDO, color:COLOR_TEXTO}}
                      className="container-states-f"
                      key={indexU}
                    >
                      <input
                        type="checkbox"
                        name={`cbox-${u.userName}`}
                        checked={
                          filterEstado.userName.includes(u.userName)
                            ? true
                            : false
                        }
                        onChange={bool =>
                          handlerClickUsers(
                            bool.target.checked,
                            u.userName
                          )
                        }
                      />
                      <label
                        
                        className="filter-priority-item-label"
                      >
                        {u.userName}
                      </label>
                    </div>
                  );
                })}

              </div>
            </div>
          </div>
        )}

      </div>
      <div className="container-filter-btn">
        <div
          style={{backgroundColor: COLOR_BOTONES}}
          className="filter-btn"
          onClick={() => handlerAplicaFiltros(filterEstado, filterRango)}
        >
          Aplicar Filtros
        </div>
      </div>
    </div>
  );
}

export default AddFilter;
